import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"

import "trix"
import "@rails/actiontext"

import '@justinribeiro/lite-youtube';

Turbo.start();

